// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2JcLr","row":"styles_row__2C9WJ"};